const values = [
  {
    title: 'Get it done',
    description: 'Tenacious and willing to pioneer where others don’t.',
  },
  {
    title: 'Be data curious',
    description:
      'Stewards of market data and ask the questions that need to be asked.',
  },
  {
    title: 'Seek clarity',
    description:
      'Keep it simple so that legal professions are accessible to all.',
  },
]

const OurValues = () => {
  return (
    <div
      className='flex flex-col items-start rounded-md bg-white gap-4 p-4 w-[323px] shadow-[0px_2px_14px_0px_rgba(184,_224,_219,_0.25),_0px_1px_4px_0px_#B8E0DB] lg:gap-4 lg:p-4 lg:w-[323px]
                    2xl:gap-6 2xl:p-6 2xl:w-[443px] 3xl:gap-10 3xl:p-10 3xl:w-[616px] position-absolute mt-[20px] lg:top-[22px] 2xl:top-[30px]  3xl:top-[40px] 2-10'
    >
      <p className='text-[#58C1B3] text-sm font-medium lg:text-sm lg:font-medium 2xl:text-lg 2xl:font-bold 2xl:leading-6 3xl:text-2xl 3xl:font-bold 3xl:leading-8'>
        Our values
      </p>
      <div className='flex flex-col items-start gap-4 self-stretch lg:gap-6'>
        {values.map((v) => (
          <div
            className='flex flex-col items-start gap-2 self-stretch lg:gap-3'
            key={v.title}
          >
            <h3 className='text-[#405985]  font-medium text-sm lg:text-lg lg:font-bold lg:tracking-wide lg:leading-6   2xl:text-2xl 2xl:leading-8 2xl:tracking-wide 2xl:font-bold 3xl:text-[32px] 3xl:leading-normal 3xl:font-bold'>
              {v.title}
            </h3>
            <p
              className='text-[#405985] font-dmSans font-medium text-xs leading-normal tracking-wide text-xs leading-normal font-medium lg:text-sm lg:leading-6 lg:font-medium
                2xl:text-lg 2xl:leading-6 2xl:font-bold  3xl:text-2xl 3xl:leading-[26px] 3xl:font-medium
  '
            >
              {v.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
export default OurValues
